//import {formValidations} from '../../../widget/FormValidations.js';
import { CONFIG } from '../../../config.js';
import {contactusSettings} from './pageSettings.js';

export const contactUsService = {
	//validateForm,
	sendEmail
};



function sendEmail(self, sender, body){
	var subject = 'Light Miles Travel Inquiry';
	var recipients = CONFIG.INQUIRY_RECIPIENT;
				
	const requestOptions = {
        method: 'POST',
        //mode: 'no-cors',
        headers: { 'Access-Control-Allow-Origin': '*',
                    'Content-Type': 'application/json'},
        //withCredentials: false,
        body: JSON.stringify({ subject, recipients, sender, body })
    };
	var errorMsg = 'Unable to send inquiry.';
	
	var res = fetch(contactusSettings.api_url.CONTACTUS, requestOptions)
        .then(handleResponse)
        .then(response => {
			if(response){
				var success = response.success;
				var message = response.message;
				var result;
				
				if(success === true){
					result = {
						success: success,
						errorMsg: ''
					};
				}
				else{
					result = {
						success: success,
						errorMsg: message ? message : errorMsg
					};
				}
			}
			else{
				result = {
					success: false,
					errorMsg: errorMsg
				};
			}
			return result;
        }).catch((error) => {
			return {
				success: false,
				errorMsg: errorMsg
			};
		});
	return res;
}

function handleResponse(response) {
    return response.text().then(text => {
        const data = text && JSON.parse(text);
        if (!response.ok) {
            if (response.status === 401) {
                // auto logout if 401 response returned from api
            }

            const error = (data && data.message) || response.statusText;
            return Promise.reject(error);
        }
        return data;
    });
}